import { render, staticRenderFns } from "./RoomMirroring.vue?vue&type=template&id=4ab0ea98&scoped=true&"
import script from "./RoomMirroring.vue?vue&type=script&lang=js&"
export * from "./RoomMirroring.vue?vue&type=script&lang=js&"
import style0 from "./RoomMirroring.vue?vue&type=style&index=0&id=4ab0ea98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab0ea98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ab0ea98')) {
      api.createRecord('4ab0ea98', component.options)
    } else {
      api.reload('4ab0ea98', component.options)
    }
    module.hot.accept("./RoomMirroring.vue?vue&type=template&id=4ab0ea98&scoped=true&", function () {
      api.rerender('4ab0ea98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Mirroring/RoomMirroring.vue"
export default component.exports